export default function resize(
  ogUrl,
  widthInPixels,
  heightInPixels,
  fit = null
) {
  const newDomain = ogUrl.replace('.s3.amazonaws.com', '.plankk.com');
  const parts = newDomain.split('/');
  let returnUrl = '';

  if (widthInPixels || heightInPixels) {
    if (parts.length > 5) {
      // Looks like a proper url format we can work with
      returnUrl = `https://${parts[2]}/${parts[3]}/${parts[4]}/${
        widthInPixels > 0 ? widthInPixels : 'AUTO'
      }x${heightInPixels > 0 ? heightInPixels : 'AUTO'}${
        fit ? '_' + fit : ''
      }/${parts[5]}`;
    }

    return returnUrl || ogUrl;
  } else {
    return ogUrl;
  }
}
